import React from "react";
 import Post from './Post/Post'
 import useStyles from './Styles.js'
 import {useSelector} from 'react-redux'
 import { Grid,CircularProgress } from "@material-ui/core";

const Posts=({setCurrentId})=>{
    const cls=useStyles();
    const posts=useSelector((state)=>state.posts)
    // console.log(posts)
    return (
        !posts.length?<CircularProgress/>:
            <Grid className={cls.m} flex={4} container alignItems="stretch" spacing={2}>
                {posts.map(post=>(
                    <Grid className={cls.m} key={post._id} item xs={12} sm={12}>
                        <Post  post={post} setCurrentId={setCurrentId}/>
                    </Grid>
                ))}
            
            </Grid>
);
}

export default Posts;